import { DataSourceMode, Layout, Slideout, SlideoutDecorator, TableRow, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutBatchRatingResults } from "./autogen/AutogenLayoutBatchRatingResults";
import { CurrencyUtil, ModelRow } from "@mcleod/core";

export class BatchRatingResults extends AutogenLayoutBatchRatingResults {

    tableResultsOnRowDisplay(event: TableRowDisplayEvent) {
        //Change the background color of the Updated fields when the Original field is different
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const originalFreightCharge = modelRow.getCurrency("original_freight_charge", null);
        const updatedFreightCharge = modelRow.getCurrency("updated_freight_charge", null);
        const compareFreightCharge = CurrencyUtil.compareCurrencies(originalFreightCharge, updatedFreightCharge)
        if (compareFreightCharge !== 0) {
            const textboxUpdatedFreightCharge = tableRow.findComponentById("textboxUpdatedFreightCharge") as Textbox;
            if (textboxUpdatedFreightCharge) {
                textboxUpdatedFreightCharge.fontBold = true;
                textboxUpdatedFreightCharge.color = compareFreightCharge < 0 ? "success" : "error";
            }
        }

        const originalOtherCharges = modelRow.getCurrency("original_other_charges", null);
        const updatedOtherCharges = modelRow.getCurrency("updated_other_charges", null);
        const compareOtherCharges = CurrencyUtil.compareCurrencies(originalOtherCharges, updatedOtherCharges);
        if (compareOtherCharges !== 0) {
            const textboxUpdatedOtherCharges = tableRow.findComponentById("textboxUpdatedOtherCharges") as Textbox;
            if (textboxUpdatedOtherCharges) {
                textboxUpdatedOtherCharges.fontBold = true;
                textboxUpdatedOtherCharges.color = compareOtherCharges < 0 ? "success" : "error";
            }
        }

        const originalTotalCharges = modelRow.getCurrency("original_total_charges", null);
        const updatedTotalCharges = modelRow.getCurrency("updated_total_charges", null);
        const compareTotalCharges = CurrencyUtil.compareCurrencies(originalTotalCharges, updatedTotalCharges);
        if (compareTotalCharges !== 0) {
            const textboxUpdatedTotalCharges = tableRow.findComponentById("textboxUpdatedTotalCharges") as Textbox;
            if (textboxUpdatedTotalCharges) {
                textboxUpdatedTotalCharges.fontBold = true;
                textboxUpdatedTotalCharges.color = compareTotalCharges < 0 ? "success" : "error";
            }
        }

        const originalTargetPay = modelRow.getCurrency("original_target_pay", null);
        const updatedTargetPay = modelRow.getCurrency("updated_target_pay", null);
        const compareTargetPay = CurrencyUtil.compareCurrencies(originalTargetPay, updatedTargetPay);
        if (compareTargetPay !== 0) {
            const textboxUpdatedTargetPay = tableRow.findComponentById("textboxUpdatedTargetPay") as Textbox;
            if (textboxUpdatedTargetPay) {
                textboxUpdatedTargetPay.fontBold = true;
                textboxUpdatedTargetPay.color = compareTargetPay < 0 ? "success" : "error";
            }
        }
        
        const originalMaxPay = modelRow.getCurrency("original_max_pay", null);
        const updatedMaxPay = modelRow.getCurrency("updated_max_pay", null);
        const compareMaxPay = CurrencyUtil.compareCurrencies(originalMaxPay, updatedMaxPay);
        if (compareMaxPay !== 0) {
            const textboxUpdatedMaxPay = tableRow.findComponentById("textboxUpdatedMaxPay") as Textbox;
            if (textboxUpdatedMaxPay) {
                textboxUpdatedMaxPay.fontBold = true;
                textboxUpdatedMaxPay.color = compareMaxPay < 0 ? "success" : "error";
            }
        }
    }
    
    static showSlideout(selectedRows: TableRow[], results: any[]) {
        const orderIds = results.map((result) => result.order_id);

        const copiedData: ModelRow[] = selectedRows
                            .filter(row => orderIds.includes(row.data.getString("order_id", null)))
                            .map((row) => row.data.createBasicCopy());
        
        copiedData.forEach((row) => {
            const result = results.find((result) => result.order_id === row.getString("order_id", null));
            if (result) {
                row.setValues({
                    "original_freight_charge": result.freight_charge,
                    "original_other_charges": result.other_charges,
                    "original_total_charges": result.total_charges,
                    "original_target_pay": result.target_pay,
                    "original_max_pay": result.max_pay,
                    "updated_freight_charge": result.updated_freight_charge,
                    "updated_other_charges": result.updated_other_charges,
                    "updated_total_charges": result.updated_total_charges,
                    "updated_target_pay": result.updated_target_pay,
                    "updated_max_pay": result.updated_max_pay
                });
            }
        });
        
        const layout =  Layout.getLayout("lme/dispatch/rates/BatchRatingResults") as BatchRatingResults;
        layout.addLayoutLoadListener(() => layout.mainDataSource.setRowsAndMode(DataSourceMode.NONE, copiedData));
        return new SlideoutDecorator({
            title: "Rate Order(s) Details",
            layout: layout,
            width: "65%",
            fillVerticalSpace: true,
            onClose: async (cancelled: boolean) => {
                layout.slideOut();
            }
        });
    }
}